import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../components/Navbar';
import '../styles/LääkeRomania.css';
import { useTranslations } from '../hooks/useTranslations';

const Lääketiede = () => {
  const [showLinks, setShowLinks] = useState(false);
  const [isFormVisible, setFormVisible] = useState(false);
  const { t } = useTranslations();

  const showForm = () => {
    setFormVisible(true);
  };

  const hideForm = () => {
    setFormVisible(false);
  };
    return (
      <div className='screen'>
        <div className="lääketiede">
        <Navbar showLinks={showLinks} setShowLinks={setShowLinks} />
        <div className='lääketiede-pic-frame' style={{ backgroundImage: `url(/lääketiede.jpg)`}} loading="lazy" decoding="async" >
        <div className='lääketiede-main'>
          <h1>{t('medicineRomania.hero.heading', 'Lääketiede Romaniassa')}</h1>
          <p>{t('medicineRomania.hero.description', 'Moni suomalainen opiskelija pohtii mahdollisuuksiaan jatkaa opintojaan ulkomailla. Yhä useampi opiskelija suuntaa ulkomaille eri lääketieteellisiin yliopistoihin kansainvälistymismahdollisuuksia etsien.')}</p>
        </div>
        </div>
        </div>
        <div className='myRomania'>
        <h1>{t('medicineRomania.why.heading', 'Miksi Romania?')}</h1>
        <div className='lääketiede-text-container'>
        <div className="lääketiede-text1">
            <div className="text1-content">
                <h2>{t('medicineRomania.why.introTitle', 'Mikä hakijoita houkuttelee ensisijaisesti?')}</h2>
                <h3>• {t('medicineRomania.why.points.acceptanceTitle', 'Hyvät sisäänpääsymahdollisuudet')}</h3>
                <p>{t('medicineRomania.why.points.acceptanceText', 'Sisäänpääsy Romanian lääketieteelliseen on huomattavasti todennäköisempää.')}</p>
                <h3>• {t('medicineRomania.why.points.teachingTitle', 'Laadukas ja käytännönläheinen opetus')}</h3>
                <p>{t('medicineRomania.why.points.teachingText', 'EU:n vaatimusten mukainen koulutus ja käytännönläheisempi opetus.')}</p>
                <h3>• {t('medicineRomania.why.points.tuitionTitle', 'Edulliset lukuvuosimaksut')}</h3>
                <p>{t('medicineRomania.why.points.tuitionText', 'Viro, Latvia ja muut Euroopan maat voivat veloittaa jopa kaksinkertaisia tai kolminkertaisia lukuvuosimaksuja verrattuna toisiin maihin. Romaniassa lukuvuosimaksu on noin 5 500 euroa.')}</p>
                <h3>• {t('medicineRomania.why.points.costOfLivingTitle', 'Alhainen elintaso, joka sopii hyvin opiskelijalle.')}</h3>
                <p>{t('medicineRomania.why.points.costOfLivingText', 'Maan yleisen alhaisen elintason vuoksi opintotuki kattaa kuukausittaiset kulut.')}</p>
            </div>
            <div className="text2-content">
                <h2>{t('medicineRomania.moreInfo.title', 'Tutustu muihin hyödyllisiin aiheisiin, kuten kansainväliset ystävyyssuhteet ja turvallisuus.')}</h2>
                <p>{t('medicineRomania.moreInfo.description', 'Romanian lääketieteelliset opiskelumahdollisuudet tarjoavat paljon enemmän kuin pelkän koulutuksen. Opiskelijat voivat luoda merkittäviä kansainvälisiä ystävyyssuhteita, samalla kun Romania tarjoaa turvallisen ympäristön opiskelijoille. Tämä yhdistelmä tekee opiskeluelämyksestä rikkaamman ja huolettomamman.')}</p>
                <button onClick={showForm}>{t('medicineRomania.moreInfo.button', 'Lue Lisää')}</button>
            </div>
        </div>
        </div>
        {isFormVisible && ( // Used in Romania.js
        <>
            <div className="overlay-lääkeromania" onClick={hideForm}></div>
            <div className="form-container-lääkeromania">
                <div className='mylääkeromania'>
                <FontAwesomeIcon
                icon={faTimes}
                className="x-button"
                onClick={hideForm}
                aria-label={t('medicineRomania.modal.close', 'Sulje lisätietolomake')}
                />
                <div className="lääkeromania-wrapper">
                    <h2>{t('medicineRomania.modal.friendsTitle', 'Kansainväliset opiskelukaverit')}</h2>
                    <p>{t('medicineRomania.modal.friendsText', 'Hakiessasi Romanian lääketieteelliseen yliopistoon, olet valmis aloittamaan uuden vaiheen elämässäsi vieraassa maassa. Voit kuitenkin olla varma, että opintojesi aikana sosiaalinen pääomasi rikastuu ja solmit pitkäkestoisia suhteita opiskelukollegoidesi kanssa. Yliopistoissa opiskelee opiskelijoita ympäri maailmaa: Amerikasta, Aasiasta, Afrikasta ja Euroopasta. Opintojen aikana ja niiden päätyttyä sinulla on mahdollisuus luoda kansainvälisiä suhteita. Suomalaisten opiskelijoiden määrä on jatkuvassa kasvussa, ja heitä löytyy jokaiselta vuosiluokalta Romanian suosituimmista yliopistoista. Vuosittain noin 120 suomalaista opiskelijaa hakee Romanian englanninkielisiin lääketieteellisiin koulutusohjelmiin.')}</p>
                <div className="lääkeromania-content">
                    <h2>{t('medicineRomania.modal.safetyTitle', 'Turvallisuus')}</h2>
                    <p>{t('medicineRomania.modal.safetyText', 'Yleinen turvallisuus on tärkeä valintakriteeri, kun lähdet opiskelemaan uuteen maahan. Siksi olemme selvittäneet Romanian turvallisuustilannetta haastattelemalla opiskelijoita ja tarkastelemalla rikostilastoja. Ennakkoluulojemme vastaisesti Romanian rikollisuustaso on verrattavissa Suomeen. Haastatteluissa opiskelijat kertoivat, etteivät ole joutuneet ongelmiin tai vaaratilanteisiin, ja poliisi auttaa ulkomaisia opiskelijoita. Yksi opiskelija kertoi unohtaneensa laukkunsa bussiin, mutta poliisin avulla sai sen takaisin saman päivän aikana. Jos tunnet olosi turvalliseksi Suomessa, tunnet samoin myös Romaniassa — opiskelijoiden mukaan maiden turvallisuustaso on hyvin samanlainen.')}</p>
                </div>
                </div>
                </div> 
            </div>
        </>
    )}
        </div>
    </div>

    );
};

export default Lääketiede;